// extracted by mini-css-extract-plugin
module.exports = {"tips":"tips_tips__3L-Pf"};